// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.session.ActivationState
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class ActivationState {
  static createActivationState(updateStamp) {
    const retVal = new ActivationState();
    retVal.initActivationState(updateStamp);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createActivationState factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawads.ActivationState";
  }
  initFromJson(json, deserializeContext) {
    this.initActivationState(json.updateStamp != null ? json.updateStamp : null);
  }
  initActivationState(updateStamp) {
    this._updateStamp = updateStamp;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["updateStamp"] = this._updateStamp;
    return retVal;
  }
  get updateStamp() {
    return this._updateStamp;
  }
  set updateStamp(value) {
    this._updateStamp = value;
  }
}
//# sourceMappingURL=ActivationState.js.map
